export const Challenge_Single_DA = {
  // Single challenge
  challenge: {
    status: {
      ongoing: "Slutter om",
      ended: "Challenge overstået",
      starting: "Starter om",
    },
    counter: {
      days: "d",
      hours: "t",
      minutes: "m",
      seconds: "s",
    },
    starts: "Starter om",
    ends: "Slutter om",
    leaderboard: {
      headline: "Leaderboard",
      tabs: {
        ALL: "Alle",
        FRIENDS: "Venner",
        FOLLOWING: "Følger",
      },
      score: {
        yours: "Dit resultat",
        others: "Hele leaderboardet",
        description: "Dit resultat vises her, så snart du deltager",
        noParticipants: "Vær den første til at deltage!",
        noFriends:
          "Du har ikke nogen venner, der aktivt deltager i denne udfordring endnu",
        noFollowing: "Du følger ikke nogen på denne konto endnu",
      },
    },
    description: {
      what: {
        headline: "Beskrivelse",
      },
      how: {
        headline: "Hvordan beregnes scoren",
      },
    },
    buttons: {
      tabs: {
        back: "Tilbage til alle",
      },
      join: "Deltag",
      joinThisChallenge: "Deltag i udfordring",
      joined: "Deltager",
      submit: "Indsend resultat",
    },
    criteria: {
      headline: "Hvordan beregnes scoren",
    },
    terms: {
      heading: "Vilkår",
      preBrand: "Du skal være til stede ved eventet og møde op ved ",
      postBrand:
        "standen den dag, du har vundet, og inden for åbningstiderne for at kunne kræve din præmie. Hvis du ikke kan møde op, kan vi desværre ikke tildele dig din ellers velfortjente præmie. Den vil i stedet blive tildelt den næste spiller på ranglisten.",
    },
    participants: {
      participating: "deltager",
      and: "og",
      more: "flere",
      participated: "deltog",
    },
    disclaimers: {
      CSGO: "CS2 er et registreret varemærke tilhørende Valve. Varemærker tilhører deres respektive ejere. Valve har ophavsret på spilmaterialet. Valve har ikke godkendt og er ikke ansvarlig for dette websted eller dets indhold.",
      Dota2:
        "Dota2 er et registreret varemærke tilhørende Valve. Varemærker tilhører deres respektive ejere. Valve har ophavsret på spilmaterialet. Valve har ikke godkendt og er ikke ansvarlig for dette websted eller dets indhold.",
      PUBG: "PUBG er et registreret varemærke tilhørende PUBG Corporation. Varemærker tilhører deres respektive ejere. PUBG Corporation har ophavsret på spilmaterialet. PUBG Corporation har ikke godkendt og er ikke ansvarlig for dette websted eller dets indhold.",
      f12022:
        "F1® 22 Game er et officielt produkt fra FIA FORMULA ONE WORLD CHAMPIONSHIP. EA, EA SPORTS, EA SPORTS-logoet, Codemasters, EGO og Codemasters-logoet er varemærker tilhørende Electronic Arts Inc. Varemærker tilhører deres respektive ejere. Electronic Arts Inc. har ikke godkendt og er ikke ansvarlig for dette websted eller dets indhold.",
      f12023:
        "F1® 23 Game er et officielt produkt fra FIA FORMULA ONE WORLD CHAMPIONSHIP. EA, EA SPORTS, EA SPORTS-logoet, Codemasters, EGO og Codemasters-logoet er varemærker tilhørende Electronic Arts Inc. Varemærker tilhører deres respektive ejere. Electronic Arts Inc. har ikke godkendt og er ikke ansvarlig for dette websted eller dets indhold.",
      fallguys:
        "Fall Guys er et registreret varemærke tilhørende Mediatonic Limited. Varemærker tilhører deres respektive ejere. Mediatonic Limited har ophavsret på spilmaterialet. Mediatonic Limited har ikke godkendt og er ikke ansvarlig for dette websted eller dets indhold.",
      fh5: "Forza Horizon er et registreret varemærke tilhørende Microsoft Studios. Varemærker tilhører deres respektive ejere. Microsoft Studios har ophavsret på spilmaterialet. Microsoft Studios har ikke godkendt og er ikke ansvarlig for dette websted eller dets indhold.",
      fm8: "Forza Motorsport er et registreret varemærke tilhørende Microsoft Studios. Varemærker tilhører deres respektive ejere. Microsoft Studios har ophavsret på spilmaterialet. Microsoft Studios har ikke godkendt og er ikke ansvarlig for dette websted eller dets indhold.",
      fortnite:
        "Fortnite er et registreret varemærke tilhørende Epic Games. Varemærker tilhører deres respektive ejere. Epic Games har ophavsret på spilmaterialet. Epic Games har ikke godkendt og er ikke ansvarlig for dette websted eller dets indhold.",
    },
    highlights: {
      heading: "Højdepunkter",
      pubg: "Get some kills in PUBG to appear in our highlights",
      fortnite: "Get some kills in Fortnite to appear in our highlights",
      new: "Nyt",
      description:
        "Deltag i udfordringen og spil for at blive vist i højdepunkterne",
    },
    creator: {
      headline: "Oprettet af",
    },
  },
};
